import PricesLoadTimeMetricIntegrationProvider from './PricesLoadTimeMetricIntegrationProvider';

export default PricesLoadTimeMetricIntegrationProvider;
